import { render, staticRenderFns } from "./GeneralFilters.vue?vue&type=template&id=bfb97744&scoped=true"
import script from "./GeneralFilters.vue?vue&type=script&lang=js"
export * from "./GeneralFilters.vue?vue&type=script&lang=js"
import style0 from "./GeneralFilters.vue?vue&type=style&index=0&id=bfb97744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb97744",
  null
  
)

export default component.exports